<div
    class="bg-shui-base-2 rounded-md shadow-[inset_0px_0px_0px_1px_rgba(var(--tint-50))] p-4 grid grid-cols-[24px_auto] items-start gap-2 cursor-pointer transition-opacity"
    [class.opacity-50]="dimmed"
    role="radio"
    [attr.aria-checked]="selected"
    [attr.aria-label]="value()"
    tabindex="0"
    (click)="onSelect()"
    (keydown.enter)="onSelect()"
    (keydown.space)="$event.preventDefault(); onSelect()"
>
    <sh-radio-button [attr.active]="selected || null" label="" aria-hidden="true"></sh-radio-button>
    <div>
        <ng-content></ng-content>
    </div>
</div>
